import React from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import './Sidebar.css';
import '../../localization/localizationService'

const Side = props => {
    //bg-light d-md-block d-none
    return (
        <Nav className="col-md-12 d-inline sidebar">
            <div className="sidebar-sticky">
                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/inventory">&#x25b8;Lagerbestand</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/articles">&#x25b8;Artikeltypen einsehen</Nav.Link>
                </Nav.Item>*/}
                <NavDropdown className="nav-drop dark-link" title="&#x25b8;FAEX Lieferung" >
                    <Nav.Item>
                        <Nav.Link as={Link} className="text-dark" to="/delivery-order">&#x25b8;{window.i18n('addDeliveryOrder')}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link as={Link} className="text-dark" to="/incoming-transactions">&#x25b8;Eingehende Lieferungen</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link as={Link} className="text-dark" to="/outgoing-transactions">&#x25b8;Ausgehende Lieferungen</Nav.Link>
                    </Nav.Item>
                </NavDropdown>
                <Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/maintain-stock">&#x25b8;Bestand pflegen</Nav.Link>
                </Nav.Item>
                {/*<Nav.Item>
                    <Nav.Link as={Link} className="text-dark" to="/transaction-history">&#x25b8;Transaktionshistorie</Nav.Link>
                </Nav.Item>*/}
            </div>
        </Nav>
    );
};
const Sidebar = withRouter(Side);
export default Sidebar